import { Sparkles } from "lucide-react";

import { relTime } from "./dates";

/**
 * Live pulse of the five most recent leads — sits above the toolbar so
 * admins see momentum at a glance. Reads the same `rows` the table renders
 * so it automatically respects the active city / category / status filters.
 */
export function RecentActivity({ rows, filterContext }) {
  const items = rows.slice(0, 5);
  if (items.length === 0) return null;
  return (
    <div
      data-testid="admin-recent-activity"
      className="mb-6 flex flex-wrap items-center gap-3 rounded-2xl border border-gold/40 bg-gradient-to-r from-gold/10 via-transparent to-transparent p-4"
    >
      <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#8B6F1F]">
        <Sparkles className="h-3.5 w-3.5" />
        Just joined
        {filterContext && (
          <span
            data-testid="admin-activity-filter"
            className="ml-1 text-[0.6rem] font-normal normal-case tracking-normal text-[#6B6B6B]"
          >
            · filtered by {filterContext}
          </span>
        )}
      </span>
      <ul className="flex flex-wrap gap-2">
        {items.map((r) => (
          <li
            key={r.id}
            data-testid={`admin-activity-${r.email}`}
            className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-3 py-1 text-xs text-[#2A2724]"
          >
            <span className="font-medium">{r.business_name}</span>
            <span className="text-[#9a9a9a]">·</span>
            <span className="text-[#6B6B6B]">
              {r.business_type || "—"} · {r.city || "—"}
            </span>
            <span className="text-[#9a9a9a]">·</span>
            <span className="text-[0.68rem] uppercase tracking-[0.16em] text-[#8B6F1F]">
              {relTime(r.created_at)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
